import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createPinia } from 'pinia'
import App from './components/App.vue'
import Home from './components/Home.vue'
import Navigation from './components/Navigation.vue'
import Structures from './components/Structures.vue'
import Structure from './components/Structure.vue'
import Tools from './components/Tools.vue'
import About from './components/About.vue'
import Admin from './components/Admin.vue'
import TagsAdmin from './components/TagsAdmin.vue'
import Analytics from './components/Analytics.vue'
import NotFound from './components/NotFound.vue'

import '../css/main.scss'
import 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'

const routes = [
  { path: '/', component: Home },
  { path: '/navigation', component: Navigation },
  { path: '/structures', component: Structures },
  { path: '/structure', component: Structure },
  { path: '/tools/renumber', component: Tools },
  { path: '/about', component: About },
  { path: '/admin/structures', component: Admin },
  { path: '/admin/tags', component: TagsAdmin },
  { path: '/admin/analytics', component: Analytics },
  { path: '/admin', redirect: '/admin/structures' },
  { path: '/tags', redirect: '/admin/tags' },
  { path: '/:pathMatch(.*)*', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const pinia = createPinia()

const app = createApp(App)
app.use(router)
app.use(pinia)
app.mount('#app')
